<template>
  <div class="form-container px-10">
    <div class="form-group mb-12 text-center">
      <h1>{{title}}</h1>
      <h3 class="form-type">2FA</h3>
    </div>
    <div class="radio-select">
      <v-radio-group row v-model="selectedMethod">
        <v-radio label="Via authenticator" :disabled="!totp"  value="authenticator" />
        <v-radio label="Via email"  value="email"/>
        <v-radio label="Via sms" :disabled="!isPhone2faActivated" value="phone"/>
      </v-radio-group>
    </div>
    <div class="form-group">
      <v-select
        v-if="phoneSelected"
        outlined
        dense
        :items="selectPhoneLabel"
        v-model="phoneLabel"
        label="Select phone number for 2FA:"
      />
      <v-select
        v-if="emailSelected"
        outlined
        dense
        :items="selectEmailLabel"
        v-model="emailLabel"
        label="Select email address for 2FA:"
      />
    </div>
    <div class="form-group">
      <v-row v-if="codeSent" class="pa-3 text-center">
        <span class="mt-1 mr-4">Code:</span>
        <CodeInput
          :key="codeRefresher"
          :fieldWidth="32"
          :fieldHeight="32"
          class="input"
          v-on:change="onChangeCode"/>
        <div v-if="phoneSelected || emailSelected" class="resend-code-btn">
        <v-btn 
          class="ml-0 mt-1" 
          :loading="btnLoading"
          text
          x-small
          @click="resend">Resend code</v-btn></div>
      </v-row>
    </div>
  </div>
</template>

<script>
import LoginStrings from "../views/Profile/LoginStrings"
import AuthPagesMixin from "../mixins/AuthPagesMixin"
import CodeInput from "vue-verification-code-input"


export default {
  name: 'LoginVerificationForm',
  mixins: [AuthPagesMixin],
  components: { CodeInput },
  data() {
    return {
      phoneLabel: "",
      emailLabel: "",
      selectPhoneLabel: [],
      selectEmailLabel: [],
      btnLoading: false,
      selectedMethod: 'email',
      codeSent: false,
      totp: false,
      code: "",
      codeRefresher: 'opt1',
    }
  },
  watch: {
    totp(val) {
      if(val == true) {
        this.selectedMethod = 'authenticator'
      }
    },
    phoneLabel: function (val) {
      this.clearCode()
      if(val){
        const phoneLabel = this.phoneLabel.split(": ")[0]
        this.axios.post(`/login/smscode/${phoneLabel}`, { langkey: "en" }).then(() => {
          this.codeSent = true
        })
      }
    },
    emailLabel: function (val) {
      this.clearCode()
      if(val){
        const emailLabel= this.emailLabel.split(": ")[0]
        this.axios.post(`/login/emailcode/${emailLabel}`, { langkey: "en" }).then(() => {
          this.codeSent = true
        })
      }
    },
    selectedMethod: function (val) {
      this.emailLabel = ""
      this.phoneLabel = ""
      this.code = ""
      this.clearCode()
      this.codeSent = (val == 'authenticator')
    },
    code: function () {
      if (this.code.length == 6) {
        this.axios
          .post(
            `/login/${this.phoneSelected? 'smsconfirmation' : this.emailSelected? 'emailconfirmation': 'totpconfirmation'}${window.location.search}`,
            { code: this.code }
          )
          .then(response => {
            if (response.data && response.data.redirecturl && response.data.redirecturl != "/") {
              window.location.href = response.data.redirecturl
            } else {
              this.login()
            }
          })
          .catch((requestCtx) => {
            this.alert(requestCtx.response)
            this.code = ""
          })
      }
    }
  },
  created: function () {
    this.axios.get("/login/twofamethods").then((response) => {
      this.totp = response.data.totp
      Object.entries(response.data.sms).forEach((entry) => {
        const [label, phone] = entry
        this.selectPhoneLabel.push(`${label}: ${phone}`)
      })
      Object.entries(response.data.email).forEach((entry) => {
        const [label, phone] = entry
        this.selectEmailLabel.push(`${label}: ${phone}`)
      })
    })
  },
  computed: {
    title() {
      return window.location.hostname.split(".").splice(1).join(".")
    },
    phoneSelected() {
      return this.selectedMethod == 'phone'
    },
    emailSelected() {
      return this.selectedMethod == 'email'
    },
    isPhone2faActivated () {
      return this.selectPhoneLabel.length > 0
    }
  },
  methods: {
    onChangeCode (v) {
      this.code = v
    },
    alert: function (response) {
      var msg = "Something went wrong"
      if (response && response.status == 422) {
        msg = LoginStrings(this, "wrong_sms_code")
      } else if (response && response.status > 400) {
        msg = LoginStrings(this, "something_went_wrong")
      }
      this.ShowInfo('error', msg)
    },

    resend() {
      this.clearCode()
      this.btnLoading = true
      this.axios
        .post(
          (this.phoneSelected? "/login/resendsms" : "/login/resendemail"),
          {
            langkey: 'en'
          }
        )
        .then(() => {
          this.ShowInfo('info', LoginStrings(this, (this.phoneSelected? `sms_resent`: `email_resent`)))
        })
        .catch((ctx) => {
          this.ShowInfo('errors', LoginStrings(this, ctx.response.data.error))
        }).finally(()=>{
          this.btnLoading = false
        })
    },
    clearCode(){
      if(this.codeRefresher == 'opt1')
        this.codeRefresher = 'opt2'
      else
        this.codeRefresher = 'opt1'
    }
  },
}
</script>

<style>
.form-container{
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-content: center;
  min-height: 500px;
  background-color: white;
}
</style>